import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';

@Component({
    selector: 'app-dropdown-field',
    imports: [IonicModule],
    template: `
        @if (readonly) {
            <ion-item lines="none">
                <ion-label>
                    <p class="field-label">{{ field.label }}</p>
                    <p class="field-value">{{ getSelectedLabel() }}</p>
                </ion-label>
            </ion-item>
        } @else {
            <ion-item>
                <ion-label position="stacked">{{ field.label }}</ion-label>
                <ion-select
                    [placeholder]="field.placeholder || 'Selecteer...'"
                    [value]="value"
                    (ionChange)="onChange($event)">
                    @for (option of options; track option.value) {
                        <ion-select-option [value]="option.value">
                            {{ option.label }}
                        </ion-select-option>
                    }
                </ion-select>
            </ion-item>
            @if (field.helpText) {
                <ion-note class="field-help">{{ field.helpText }}</ion-note>
            }
        }
    `,
    styles: [`
        .field-help {
            padding: 4px 16px;
            font-size: 12px;
        }
        .field-label {
            color: var(--ion-color-medium);
            font-size: 12px;
        }
        .field-value {
            white-space: pre-wrap;
        }
    `]
})
export class DropdownFieldComponent extends BaseFieldComponent {
    get options() {
        return this.field?.options || [];
    }

    initialize(value: any): void {
        this.value = value ?? '';
    }

    serialize(): any {
        return this.value;
    }

    onChange(event: any): void {
        this.emitChange(event.detail.value);
    }

    getSelectedLabel(): string {
        if (!this.value) return '-';
        const option = this.options.find(o => o.value === this.value);
        return option?.label || this.value;
    }
}
